<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn text rounded color="primary" :to="{name: 'ClientesLista'}" exact>
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->

      <template v-slot:actions>
        <v-btn
          text
          rounded
          :disabled="salvando"
          @click="$router.push({name: 'ClientesLista'})"
        >Cancelar</v-btn>
        <v-btn
          depressed
          rounded
          color="primary"
          :loading="salvando"
          :disabled="!form_valido"
          @click="confirmar"
          >Salvar</v-btn>
      </template>
    </z-centralized-toolbar>

    <z-container v-if="!$store.state.loading">
      <!-- <h3 class="headline mb-3">{{ titulo }} Cliente</h3> -->

      <v-form ref="form" v-model="form_valido" lazy-validation >
        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Identificação
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row dense>
              <v-col sm="12">
                <z-text-field
                  v-model="cliente.razao"
                  label="Razão Social"
                  autofocus
                  filled
                  dense
                  upper
                  :rules="regras.razao"
                ></z-text-field>
              </v-col>
              <v-col sm="12">
                <v-text-field
                  v-model="cliente.fantasia"
                  label="Nome Fantasia"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col sm="2">
                <v-select
                  v-model="cliente.tipo_pessoa"
                  label="Pessoa"
                  filled
                  dense
                  :items="$globals.TIPO_PESSOA"
                ></v-select>
              </v-col>
              <v-col sm="3">
                <z-cpf-cnpj
                  v-model="cliente.cpfcnpj"
                  label="CPF/CNPJ"
                  filled
                  dense
                ></z-cpf-cnpj>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="cliente.rg_inscricao"
                  label="RG/Inscrição"
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model="cliente.contato"
                  label="Contato"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- <v-row dense>
              <h3 class="subheader">Endereçamento</h3>
            </v-row> -->
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Endereçamento
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="2">
                <z-cep
                  v-model="cliente.cep"
                  buscarcep
                  filled
                  dense
                  @resultado="preencherEndereco"
                ></z-cep>
              </v-col>
              <v-col sm="8">
                <v-text-field
                  v-model="cliente.endereco"
                  label="Endereço"
                  filled
                  dense
                  @input="(value) => (cliente.endereco = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field
                  v-model="cliente.numero"
                  ref="numero"
                  label="Número"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="5">
                <v-text-field
                  v-model="cliente.bairro"
                  label="Bairro"
                  filled
                  dense
                  @input="(value) => (cliente.bairro = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="5">
                <v-text-field
                  v-model="cliente.cidade"
                  label="Cidade"
                  filled
                  dense
                  @input="(value) => (cliente.cidade = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="cliente.estado"
                  label="Estado"
                  filled
                  dense
                  :items="$globals.ESTADOS"
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="12">
                <v-text-field
                  v-model="cliente.complemento"
                  label="Complemento"
                  filled
                  dense
                  @input="(value) => (cliente.complemento = value.toUpperCase())"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col sm="3">
                <v-text-field
                  v-model="cliente.telefone"
                  v-mask="$globals.TELEFONE_MASK"
                  label="Telefone"
                  return-masked-value
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="cliente.celular"
                  v-mask="$globals.CELULAR_MASK"
                  label="Celular/WhatsApp"
                  return-masked-value
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-text-field
                  v-model="cliente.email"
                  label="Email"
                  required
                  filled
                  dense
                  :rules="regras.email"
                  @input="(value) => (cliente.email = value.toLowerCase())"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Limite de Compras
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="3">
                <z-campo-valor
                  label="Limite de Compras"
                  v-model="cliente.limite_compra"
                  filled
                  dense
                ></z-campo-valor>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="cliente.prazo"
                  label="Prazo"
                  suffix="dias"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>


          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title class="text-subtitle-2">
            Observações
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row dense>
              <v-col sm="12">
                <v-textarea
                  v-model="cliente.observacoes"
                  label="Observações"
                  filled
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
            
          <v-divider></v-divider>
          <v-card-actions>
            <v-switch
            class="my-0"
            color="primary"
            label="Ativo"
            v-model="cliente.ativo"
            v-show="$route.meta.editando"
            hide-details
            filled
            dense
            ></v-switch>
          </v-card-actions>
        </v-card>
      </v-form>
    </z-container>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "clientes-form",
  data() {
    return {
      cliente: {
        tipo_pessoa: "F",
        estado: "PE",
        cpfcnpj: "",
        estado: "",
        cpfcnpj: "",
        cep: "",
        endereco: "",
        bairro: "",
        cidade: "",
        // limite_compra: 0
      },
      salvando: false,
      regras: {},
      tab: "",
      form_valido: false,
      regras: {
        razao: [(v) => !!v || "É necessário preencher a Razão Social"],
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    this.UNSET_CLIENTE();
    next();
  },

  async mounted() {
    this.setTitulo(this.titulo);

    if (this.$route.name == "ClientesEditar") {
      if (!this.$store.state.clientes.cliente.id) {
        if (this.$route.params.id) {
          await this.abrir(this.$route.params.id);
        }
      }
      this.cliente = this.clone(this.$store.state.clientes.cliente);
    }
  },

  methods: {
    ...mapMutations(["setTitulo"]),
    ...mapMutations("clientes", ["UNSET_CLIENTE"]),
    ...mapActions("clientes", ["abrir", "atualizar", "salvar"]),

    async confirmar() {
      try {
        this.salvando = true;

        if (this.$route.params.id) {
          await this.atualizar(this.cliente);
        } else {
          await this.salvar(this.cliente);
        }
        this.$router.push({name: 'ClientesLista'});
        this.$eventbus.notificar("Cliente salvo com sucesso");
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível salvar este Cliente. Verifique os dados preenchidos.",
          error
        );
      } finally {
        this.salvando = false;
      }
    },

    preencherEndereco(endereco) {
      if (endereco.erro) {
        this.cliente.endereco = "";
        this.cliente.bairro = "";
        this.cliente.cidade = "";
        this.cliente.estado = "";
        // this.cliente.ibge  = '';
      } else {
        this.cliente.endereco = endereco.logradouro.toUpperCase();
        this.cliente.bairro = endereco.bairro.toUpperCase();
        this.cliente.cidade = endereco.localidade.toUpperCase();
        this.cliente.estado = endereco.uf.toUpperCase();
        // this.cliente.ibge  = endereco.ibge;
        this.$refs.numero.focus();
      }
    },
  },

  computed: {
    titulo() {
      let titulo = this.$route.meta.editando ? "Editar" : "Adicionar";
      return titulo + " " + "Cliente";
    },
  },

  watch: {
    "cliente.cpfcnpj"(val, oldval) {
      if (val) {
        this.cliente.tipo_pessoa = val.length > 14 ? "J" : "F";
      }
    },
  },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
